
	import { defineComponent } from 'vue'
	import { useRoute } from 'vue-router'

	import AntennaBundles from '@/sections/AntennaBundles.vue'
	import ChannelBoxes from '@/sections/ChannelBoxes.vue'
	import CallToActivate from '@/sections/dividers/CallToActivate.vue'
	import PayAsYouGo from '@/sections/dividers/PayAsYouGo.vue'
	import GetOurGuide from '@/sections/GetOurGuide.vue'
	import VideoSteps from '@/sections/VideoSteps.vue'

	import { useClaimCoupon, useReferralInformation } from '../composables/useBackend'

	export default defineComponent({
		components: {
			VideoSteps,
			AntennaBundles,
			GetOurGuide,
			PayAsYouGo,
			CallToActivate,
			ChannelBoxes,
		},

		async setup() {
			const { params } = useRoute()
			const id = Array.isArray(params.referralId) ? params.referralId[0] : params.referralId
			await useReferralInformation(id)

			const { couponCode, email, isStatus, claim } = useClaimCoupon(id)

			return {
				email,
				couponCode,
				isLoading: isStatus('Loading'),
				isSuccessful: isStatus('Completed'),
				isInvalid: isStatus('Invalid'),
				claim,
			}
		},
	})
